import type { AppSessionPhase } from "./AppSession.js";

export type ProtectedLayoutMode =
  | "boot"
  | "error"
  | "anonymous"
  | "workspace-gate"
  | "simulation-gate"
  | "shell";

export function resolveProtectedLayout(
  phase: AppSessionPhase,
  workspaceCount: number,
  simulation: boolean,
): ProtectedLayoutMode {
  if (phase === "booting") return "boot";
  if (phase === "error") return "error";
  if (phase === "anonymous") return "anonymous";
  if (workspaceCount === 0) return simulation ? "simulation-gate" : "workspace-gate";
  return "shell";
}
